import type {
  OsEmailCopy,
  OsEmailCopyContext,
} from "./os-notification-copy-types";

export function buildNewLeadCopy(
  ctx: OsEmailCopyContext,
): Omit<OsEmailCopy, "why"> {
  const deal = ctx.deal;
  const who = deal?.contactName ?? deal?.contactEmail ?? "A buyer";
  const listings = deal?.listings ?? [];
  const listing = listings[0];
  const partner = ctx.recipient.partnerName
    ? ` from ${ctx.recipient.partnerName}`
    : "";
  const isBuyer = deal?.pipelineType === "BUYER";
  const label =
    deal?.contactName && deal.title !== deal.contactName
      ? `${deal.contactName} (${deal.title})`
      : (deal?.contactName ?? deal?.title ?? "this lead");
  const inquiry =
    listings.length > 1
      ? `${listings.length} of your listings`
      : listing?.title;
  return {
    subject: isBuyer
      ? inquiry
        ? `Buyer inquiry: ${who} — ${inquiry}`
        : `${who} is looking for a business broker${partner}`
      : `New seller lead${partner}: ${label}`,
    preheader: listing
      ? [
          listing.location,
          listing.askingPriceLabel,
          deal?.messageExcerpt?.replace(/\s+/g, " ").slice(0, 160) ??
            "Review the inquiry and respond to the buyer.",
        ]
          .filter(Boolean)
          .join(" · ")
      : isBuyer
        ? "A buyer requested your help finding a business to buy. Review their message and respond."
        : "Review the seller's details and confirm whether you can help sell their business.",
    headline: isBuyer
      ? inquiry
        ? `${deal?.contactFirstName ?? who} is interested in buying ${listings.length > 1 ? "a business" : "this business"}`
        : `${deal?.contactFirstName ?? who} wants your help buying a business`
      : `${deal?.contactFirstName ?? who} wants help selling a business`,
    body: [
      isBuyer
        ? inquiry
          ? `${who} contacted you through Venturu to discuss buying this business. Read their message below, then reply to arrange the next step.`
          : `${who} requested your help buying a business through Venturu. Review their message and ask about their budget, preferred industry, and timing.`
        : `A seller lead${partner} is ready for your review. Check the business details and contact the seller to confirm their goals.`,
    ],
    ctaLabel: isBuyer ? "Reply to buyer" : "Reply to seller",
    actions: ["mute_deal", "not_interested"],
  };
}
